import { default as SiteHeaderMobile } from './SiteHeaderMobile';
import SiteHeaderContainer from '../SiteHeader.container';
import SiteHeaderMobileSubmitDropdown from '../SiteHeaderMobile.submit_dropdown_mobile';
import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
export default withFeatureBranch({
    submit_dropdown_mobile: SiteHeaderMobileSubmitDropdown,
})(SiteHeaderContainer(SiteHeaderMobile));
//# sourceMappingURL=index.js.map